import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';
import { RenderedService } from '../../rendered.service';
import { IntegrationsService } from '@services/integrations.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { CourseService } from '@scaffold/services/course.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'scaffold-integration',
    templateUrl: './scaffold-integration.component.html',
    styleUrls: [
        '../../rendered.component.scss',
        './scaffold-integration.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ScaffoldIntegrationComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  @Output() change = new EventEmitter<any>();
  public destroy$: Subject<boolean> = new Subject<boolean>();
  integrationList = [];
  integrations = [];

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private integrationService: IntegrationsService,
    private courseService: CourseService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        if (!this.cdr['destroyed']) {
          this.cdr.detectChanges();
        }
      });

    let partnerId = this.courseService.getPartnerId();
    this.integrationService
      .getIntegrations(this.item.integration_type, null, false, partnerId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(integrations => {
        let visiblIntegration;
        console.log(this.item);
        if (this.item.filter && this.item.filter.value) {
          console.log('Has Filter');
          let filter: Array<any> = this.item.filter.value.split(/\|/g);
          visiblIntegration = integrations.filter(i => {
            console.log(i.name, filter);
            return filter.includes(i.name);
          });
        } else {
          visiblIntegration = integrations;
        }
        this.integrationList = visiblIntegration;
        this.update();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  update() {
    this.integrations = [];
    var selectedIntegrations = [];
    if (this.value?.split) {
      selectedIntegrations = this.value?.split('|');
    }

    this.integrationList?.forEach(integration => {
      integration.selected = selectedIntegrations.includes(integration.name);

      this.integrations.push(integration);
    });
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  integrationsUpdated() {
    var integrationsSelected = 0;
    var value = '';
    this.integrations.forEach(integration => {
      if (integration.selected) {
        if (integrationsSelected > 0) {
          value += '|';
        }

        value += integration.name;
        integrationsSelected++;
      }
    });

    this.item.value = value;
    this.change.emit({ value: value });
  }
}
